import LogIn from './LogIn';
import errors from './errors';
import HomePage from './HomePage';
import Cities from './Cities';
import Buttons from './Buttons';
import Etc from './Etc';
import Stock from './Stock';
import Role from './Role';
import User from './User';
import Contract from './Contract';
import Appeal from './Appeal';
import Support from './Support';
import BoxBooking from './BoxBooking';
import validation from './validation';
import SignUp from './SignUp';
import Payment from './Payment';

export default {
	LogIn,
	errors,
	HomePage,
	Cities,
	Buttons,
	Etc,
	Stock,
	Role,
	User,
	Contract,
	Appeal,
	Support,
	BoxBooking,
	validation,
	SignUp,
	Payment,
};
